<template>
<div id="app">
  <router-view v-if="isRouterAlive"></router-view>
</div>
</template>
<script>
import $ from "jquery";
import Home from "components/Home";
import VueCookies from "vue-cookies";
import Consts from './consts';
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload
    };
  },
  components: {
    Home
  },
  methods: {
    reload: function() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    }
  },
  data() {
    $(function() {
      let url = window.location.href;
      if (url.indexOf("company") >= 0) {
        $("body").attr("class", "company");
      } else if (url.indexOf("service") >= 0) {
        $("body").attr("class", "service");
      } else if (url.indexOf("products") >= 0) {
        $("body").attr("class", "product");
      } else if (url.indexOf("media") >= 0) {
        $("body").attr("class", "media");
      }

      let host_str = window.location.host.toString();
      if (host_str.indexOf("www.en.arivotyre.com") > -1) {
        VueCookies.set(Consts.COOKIE_LANG, "en");
      } else if (host_str.indexOf("www.es.arivotyre.com") > -1) {
        VueCookies.set(Consts.COOKIE_LANG, "es");
      } else if (host_str.indexOf("www.ru.arivotyre.com") > -1) {
        VueCookies.set(Consts.COOKIE_LANG, "ru");
      } else {
        VueCookies.set(Consts.COOKIE_LANG, "en");
      }
    });
    const NativeLang = (navigator.language || navigator.userLanguage).substr(
      0,
      2
    );

    return {
      isRouterAlive: true
    };
  }
};
</script>
<style>
html,
body,
#app {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue